import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useRefCallback, useRefFunction } from '@tencent/glue-react-use';
import { LibraryUploadStep } from '../../../context/MaterialPanelContext';
import { getHumanSizeStr } from '../../common/utils';
import { VideoUploadStatus, videoUploadRequest } from '../util/videoUploadRequest';
import { selectVideoFile } from '../util/util';
import { useRcMaterialPanel } from '../../MaterialPanel/RcMaterialPanel/RcMaterialPanel';
import { VIDEO_ACCEPT_TYPES, VIDEO_MAX_SIZE_LIMIT } from '../../common/const';
export var useVideoUpload = function useVideoUpload(props) {
  var _props$uploadConfig = props.uploadConfig,
    request = _props$uploadConfig.request,
    uid = _props$uploadConfig.uid,
    localUpload = _props$uploadConfig.localUpload,
    idUpload = _props$uploadConfig.idUpload,
    value = props.value,
    onValueChange = props.onValueChange;
  var _useRcMaterialPanel = useRcMaterialPanel(),
    currentUploadFileDetail = _useRcMaterialPanel.currentUploadFileDetail,
    setErrMsg = _useRcMaterialPanel.setErrMsg,
    setStep = _useRcMaterialPanel.setStep,
    setCurrentUploadDetail = _useRcMaterialPanel.setCurrentUploadDetail;
  var responseHandler = useRefCallback(function (poolResp) {
    if (poolResp.status === VideoUploadStatus.ERROR) {
      setErrMsg(poolResp.value);
      setStep(LibraryUploadStep.FAIL);
    } else if (poolResp.status === VideoUploadStatus.FAIL || poolResp.status === VideoUploadStatus.SUCCESS) {
      var nextValue = _toConsumableArray(value);
      if (poolResp.status === VideoUploadStatus.FAIL) {
        nextValue[0] = poolResp;
        setErrMsg('视频转码失败');
        setStep(LibraryUploadStep.FAIL);
      } else {
        var videoName = currentUploadFileDetail.fileName;
        videoName = /\.mp4$/.test(videoName) ? videoName : "".concat(videoName, ".mp4");
        nextValue[0] = {
          status: poolResp.status,
          value: _objectSpread(_objectSpread({}, poolResp.value), {}, {
            video_name: videoName
          })
        };
        setStep(LibraryUploadStep.SUCCESS);
      }
      onValueChange(nextValue);
    }
  });
  var uploadIdFile = useRefFunction(function (ops) {
    var poster = ops.poster,
      mediaId = ops.mediaId,
      name = ops.name;
    setStep(LibraryUploadStep.UPLOADING);
    var _videoUploadRequest = videoUploadRequest({
        request: request,
        url: idUpload.url,
        requestData: {
          mediaId: Number(mediaId)
        }
      }),
      requestResult = _videoUploadRequest.requestResult,
      abort = _videoUploadRequest.abort;
    setCurrentUploadDetail({
      poster: poster,
      abort: abort,
      fileName: name
    });
    requestResult.then(responseHandler);
  });
  var uploadLocalFile = useRefCallback(function () {
    var _localUpload$accept = localUpload.accept,
      accept = _localUpload$accept === void 0 ? VIDEO_ACCEPT_TYPES : _localUpload$accept,
      _localUpload$sizeLimi = localUpload.sizeLimit,
      sizeLimit = _localUpload$sizeLimi === void 0 ? VIDEO_MAX_SIZE_LIMIT : _localUpload$sizeLimi,
      url = localUpload.url;
    selectVideoFile({
      accept: accept
    }).then(function (fileDetail) {
      var file = fileDetail.file,
        poster = fileDetail.poster,
        size = fileDetail.size,
        name = fileDetail.name;
      if (size > sizeLimit) {
        setErrMsg("\u6587\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7".concat(getHumanSizeStr(sizeLimit, 0)));
        setStep(LibraryUploadStep.FAIL);
        return;
      }
      var formData = new FormData();
      formData.append('file', file);
      formData.append('fileName', file.name);
      formData.append('uid', uid);
      setStep(LibraryUploadStep.UPLOADING);
      var _videoUploadRequest2 = videoUploadRequest({
          request: request,
          url: url,
          requestData: formData
        }),
        requestResult = _videoUploadRequest2.requestResult,
        abort = _videoUploadRequest2.abort;
      setCurrentUploadDetail({
        poster: poster,
        fileName: name,
        abort: abort
      });
      requestResult.then(responseHandler);
    });
  });
  return {
    uploadIdFile: uploadIdFile,
    uploadLocalFile: uploadLocalFile
  };
};